import {useCallback, useRef, useState} from 'react';

import {Coordinate} from '~/shared/components/Maps/types';
import {adjustCenterAndZoom, mapGoogleLatLngToCoordinate} from '~/shared/components/Maps/utils';
import {INITIAL_MAP_CENTER, INITIAL_MAP_ZOOM} from '~/shared/components/Maps/consts';

const useRecenter = () => {
  const [optimalZoom, setOptimalZoom] = useState(INITIAL_MAP_ZOOM);
  const [optimalCenter, setOptimalCenter] = useState<Coordinate>(INITIAL_MAP_CENTER);
  const isAutoRecenterRef = useRef<boolean>(false);

  const isAutoRecenter = useCallback(() => isAutoRecenterRef.current, []);

  const recenterMapHandler = useCallback((props: Parameters<typeof adjustCenterAndZoom>[0]) => {
    isAutoRecenterRef.current = true;
    adjustCenterAndZoom(props);
    setOptimalCenter(mapGoogleLatLngToCoordinate(props.map.getCenter()) || INITIAL_MAP_CENTER);
    setOptimalZoom(prev => props.map.getZoom() || prev);
    isAutoRecenterRef.current = false;
  }, []);

  return {
    isAutoRecenter,
    recenterMapHandler,
    optimalCenter,
    optimalZoom,
  };
};

export default useRecenter;
